import request from './request'

export function getScanCode(url) {
  return request({
    url: '/api/login/getScanCode',
    method: 'get',
    params: { url }
  })
}

export function wechatCallback(code, state) {
  return request({
    url: '/api/login/wechat/callback',
    method: 'get',
    params: { code, state }
  })
}
export function getUserInfo() {
  return request({
    url: '/api/user/info',
    method: 'get',
  })
}

export function sendSmsCode(data) {
  return request({
    url: '/api/sms/sendCode',
    method: 'post',
    data
  })
}
export function updateUser(data) {
  return request({
    url: '/api/user/updateUser',
    method: 'post',
    data
  })
}

export function register(data) {
  return request({
    url: '/api/login/register',
    method: 'post',
    data
  })
}

export function loginEmail(data) {
  return request({
    url: '/api/login/mobileLogin',
    method: 'post',
    data
  })
}

export function login(data) {
  return request({
    url: '/vue-admin-template/user/login',
    method: 'post',
    data
  })
}

export function getInfo(token) {
  return request({
    url: '/api/user/info',
    method: 'get',
    params: { token }
  })
}

export function logout() {
  return request({
    url: '/api/login/logout',
    method: 'post'
  })
}

export function testLogin(data) {
  return request({
    url: '/api/login/mobileLogin',
    method: 'post',
    data
  })
}

export function testbindMnp(data) {
  return request({
    url: '/api/user/bindMnp',
    method: 'post',
    data
  })
}
export function test_bindMobile(data) {
  return request({
    url: '/api/user/bindMobile',
    method: 'post',
    data
  })
}
export function test_bindOa(data) {
  return request({
    url: '/api/user/bindOa',
    method: 'post',
    data
  })
}
export function test_center(data) {
  return request({
    url: '/api/user/center',
    method: 'get',
    data
  })
}
export function changePwd(data) {
  return request({
    url: '/api/user/changePassword',
    method: 'post',
    data
  })
}
export function test_forgotPwd(data) {
  return request({
    url: '/api/user/forgotPwd',
    method: 'post',
    data
  })
}
export function test_getMobileByMnp(data) {
  return request({
    url: '/api/user/getMobileByMnp',
    method: 'post',
    data
  })
}
export function test_uesrinfo(data) {
  return request({
    url: '/api/user/info',
    method: 'get',
    data
  })
}

export function test_resetPassword(data) {
  return request({
    url: '/api/user/resetPassword',
    method: 'post',
    data
  })
}
export function test_setInfo(data) {
  return request({
    url: '/api/user/setInfo',
    method: 'post',
    data
  })
}
export function test_updateUser(data) {
  return request({
    url: '/api/user/updateUser',
    method: 'post',
    data
  })
}

export function loginAccount(data) {
  return request({
    url: '/api/login/account',
    method: 'post',
    data
  })
}